import styles from "./workshops.module.css";

type Voter = { id: string; name: string; text: string };

export function WorkshopVoters({ voters }: { voters: Voter[] }) {
  return (
    <span className={styles.choiceVoters}>
      {voters.slice(0, 3).map((voter) => (
        <span
          key={voter.id}
          role="img"
          aria-label={voter.text ? `${voter.name}: ${voter.text}` : voter.name}
          title={voter.text ? `${voter.name}: ${voter.text}` : voter.name}
          className={styles.voterAvatar}
        >
          {voter.name
            .trim()
            .split(/\s+/)
            .slice(0, 2)
            .map((part) => part[0])
            .join("")
            .toUpperCase()}
        </span>
      ))}
      {voters.length > 3 && (
        <span
          className={styles.voterAvatar}
          title={voters
            .slice(3)
            .map((voter) => voter.name)
            .join(", ")}
        >
          +{voters.length - 3}
        </span>
      )}
    </span>
  );
}
